import { FormGroup } from '@angular/forms';

export interface IValidateDateTime {
  parentField: string;
  compareDateWith: string;
  compareTimeWith: string;
  comparisonType: string;
  message: string;
}

/**
 * ENUM for extracting params for specific types
 */
export enum ParamsType {
  'FORM_VALUE' = 'FORM_VALUE',
  'STATIC' = 'STATIC',
  'SESSION' = 'SESSION',
  'RESPONSE' = 'RESPONSE',
  'FUNCTION' = 'FUNCTION'
}

export interface ApiSchema {
  url: string;
  type: string;
  name: string;
  params: Array<ApiParamsSchema>;
  sessionParams?: Array<ApiParamsSchema>;
  event: string;
}

export interface ApiParamsSchema {
  key: string;
  type: ParamsType;
  value: string;
  mandatory: boolean;
}

export interface SubDomain {
  online: Array<any> | object;
  backoffice: Array<any> | object;
}

/**
 * ENUM for subdomain
 */
export enum SubDomains {
  'online' = 'online',
  'backoffice' = 'backoffice'
}

/**
 * ENUM for date validation types
 */
export enum DateValidationTypes {
  STATIC = 'STATIC',
  FORM_VALUE = 'FORM_VALUE',
  COMPARE = 'COMPARE',
  CURRENT = 'CURRENT',
  YESTERDAY = 'YESTERDAY',
  TOMORROW = 'TOMORROW',
  LATEST_AMONG = 'LATEST_AMONG',
  FIRST_AMONG = 'FIRST_AMONG',
  SESSION = 'SESSION'
}

/**
 * ENUM for validation param types
 */
export enum ValidationParamTypes {
  CURRENT = 'CURRENT',
  FORM_VALUE = 'FORM_VALUE',
  SESSION = 'SESSION',
  FUNCTION = 'FUNCTION'
}

export interface ValidationParamSchema {
  key: string;
  type: ValidationParamTypes;
  value: string;
}

export interface ValidationsSchema {
  isActive: boolean;
  message: string;
  value: any;
  type: DateValidationTypes;
  params: Array<ValidationParamSchema>;
}

export interface HideShowSchema {
  type: HideShowType;
  key: string;
  value: any;
  params: Array<any>;
}

/**
 * ENUM for hide show form field types
 */
export enum HideShowType {
  STATIC = 'STATIC',
  FUNCTION = 'FUNCTION',
  FORM_VALUE = 'FORM_VALUE'
}

export interface AgeCheckParam {
  age: number;
  dob: any;
}

export interface ControlInputs {
  field: object;
  form: FormGroup;
  type: string;
  dynamicControlScope: any;
  parentFormScope: any;
}

/**
 * ENUM for http method types
 */
export enum HttpMethods {
  Get = 'GET',
  Post = 'Post'
}

export interface OnChangeEvent {
  functionName: string;
  params: Array<ApiParamsSchema>;
}

export interface Languages {
  cultureCode?: string;
  description?: string;
  id?: number;
  languageCode?: string;
  masterCode?: string;
}

export interface ApplicationDetails {
  countryCode: string;
  missionCode: string;
  centerCode: string;
  loginUser: string;
  visaCategoryCode: string;
  isEdit: boolean;
  applicantList: Array<ApplicantList>;
}

export interface ApplicantList {
  urn: any;
  arn: any;
  loginUser: any;
  firstName: any;
  lastName: any;
  salutation: any;
  gender: any;
  contactNumber: any;
  dialCode: any;
  passportNumber: any;
  passportExpirtyDate: any;
  dateOfBirth: any;
  emailId: any;
  nationalityCode: any;
  stateCode: any;
  cityCode: any;
  isEndorsedChild: any;
  applicantType: any;
  addressline1: any;
  addressline2: any;
  pincode: any;
  // referenceNumber: any;
  applicantGroupId: any;
  parentPassportNumber: any;
  parentPassportExpiry: any;
  dateOfDeparture: any;
  gwfNumber: any;
}

export interface Datepicker {
  year: number;
  month: number;
  day: number;
}

/**
 * Enum for type NgbDatepicker
 */
export enum DatepickerKey {
  year = 'year',
  month = 'month',
  day = 'day'
}

/**
 * Format of date
 * NOTE: Any change to below enum should be reflected in IDateFormats also.
 */
export enum DateFormats {
  D_M_Y_SLASH = 'dd/mm/yyyy',
  M_D_Y_SLASH = 'mm/dd/yyyy',
  Y_M_D_SLASH = 'yyyy/dd/mm'
}

/**
 * Missions list
 * NOTE:- Country code should be Alpha-3 code as per ISO 3166
 */
export enum Mission {
  THA = 'tha',
  SUR = 'sur',
  PRECHECK = 'PreCheck',
  VNM = 'vnm',
  VAS = 'vas'
}
